/* OAuth return landing. supabase-js (detectSessionInUrl) completes the PKCE code
 * exchange asynchronously on load; we wait for the session to hydrate via the auth
 * listener, then route the user onward (home by default). A short fallback avoids
 * getting stuck here if the exchange never yields a session (e.g. the user denied
 * access) — after it elapses we send them back to login. */
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "../Admin/icons/icons";
import { useAuth } from "./AuthProvider";
import "./auth.css";

const FALLBACK_MS = 8000;

export function AuthCallback(): React.ReactElement {
  const { session } = useAuth();
  const navigate = useNavigate();

  // As soon as a session exists, leave for home.
  useEffect(() => {
    if (session) navigate("/", { replace: true });
  }, [session, navigate]);

  // Safety net: if no session has arrived after the exchange should have finished,
  // return to login rather than spinning forever.
  useEffect(() => {
    const t = setTimeout(() => {
      if (!session) navigate("/login", { replace: true });
    }, FALLBACK_MS);
    return () => clearTimeout(t);
  }, [session, navigate]);

  return (
    <div className="auth-callback">
      <span className="spin">
        <Spinner size={28} />
      </span>
      <span>Signing you in…</span>
    </div>
  );
}
